import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import './style.css';

import angular from 'angular';
import ngresource from 'angular-resource';
import nganimate from 'angular-animate';
import ngmessages from 'angular-messages';
import ngstorage from 'ngstorage';
import ngcookies from 'angular-cookies';
import uirouter from 'angular-ui-router';
import uibootstrap from 'ui-bootstrap4';
import breadcrumb from 'angular-breadcrumb';
import updatemeta from 'angular-update-meta';
import socialshare from 'angular-socialshare';
import ngbase64 from 'angular-base64';

import routing from './app.config';
import navigation from './components/navigation';
import login from './components/login';
import catalogue from './components/catalogue';
import serials from './components/serials';
import serials2 from './components/serials2';
import ec from './components/ec';
import names from './components/names';
import orgs from './components/orgs';
import subj from './components/subj';
import ap from './components/ap';
import help from './components/help';
//import account from './components/account';
import lk from './components/lk';
import record from './components/record';
import itemorder from './components/itemorder';
import orderrenewal from './components/orderrenewal';
import renewalorders from './components/renewalorders';
import favorities from './components/favorities';
import basket from './components/basket';
import search from './components/search';
import document from './components/document';
import kbsearch from './components/kbsearch';
import kb from './components/kb';
import kbadmin from './components/kbadmin';
import catalog from './components/catalog';
import database from './components/database';
import storage from './components/storage';
import backbutton from './components/backbutton';
import home from './components/home';
import recommendations from './components/recommendations';
import app from './components/app';

angular.module('app', [
    ngresource,
    nganimate,
    ngmessages,
    uirouter,
    uibootstrap,
    ngstorage.name, // Notes for ngstorage -- https://github.com/gsklee/ngStorage/issues/250
    ngcookies,
    'ncy-angular-breadcrumb',
    'updateMeta',
    '720kb.socialshare',
    'base64',
    record,
    favorities,
    basket,
    catalog, database, storage,
    navigation, catalogue,
    serials, serials2,
    ec, names, orgs, subj, ap, login, help, lk, search, document,
    itemorder, orderrenewal, renewalorders, kbsearch, kbadmin, kb, backbutton, home, recommendations, app
])
    .config(routing)
    .config(['$breadcrumbProvider', function($breadcrumbProvider) {
        $breadcrumbProvider.setOptions({template: require('./breadcrumb.template.pug')})
    }])
    .constant('appconfig', {
        apiEndpoint: process.env.API_ENDPOINT,
        apiLFEndpoint: process.env.API_LF_ENDPOINT

    })   
    .run(function() {
        console.log('App loaded.');
    });


/* New verson */
if (!String.prototype.includes) {
    String.prototype.includes = function(search, start) {
        'use strict';
        if (typeof start !== 'number') {
            start = 0;
        }
        if (start + search.length > this.length) {
            return false;
        } else {
            return this.indexOf(search, start) !== -1;
        }
    };
}
